import React, { useState, useEffect, useMemo } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { useAtom } from "jotai";
import classes from "../../../assets/styles/Contact.module.css";
import { FILE_UPLOAD } from "../../../utils/constants/apiUrl";
import { get, deleteRecord, post, put } from "../../../server";
import showToast from "../../../helpers/showToast";
import { loggedInUser } from "../../../utils/store";
import Loader from "../../../components/Loader";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import FormInput from "../../../components/Forms/FormInput";
import searchIcon from "../../../assets/images/global_icons/searchicon.svg";
import FileUploadAddEditModal from "../../../components/Modals/FileUploadAddEditModal";
import { formatUrl } from "../../../utils/functions/index";
import _ from "lodash";
import baseUrl from "../../../utils/constants/baseUrl";

const AllFileUpload = () => {
  let emptyCustomUrlData = {
    isNew: true,
    id: "",
    title: "",
    url_path: "",
  };

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const [files, setFiles] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(emptyCustomUrlData);

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  // Handle main modal
  const handleShowModal = (obj) => {
    if (obj && Object.keys(obj).length) setSelectedData(obj);
    setShowModal(true);
  };

  const handleSaveShowModal = async () => {
    setLoading(true);

    let payload = _.cloneDeep(selectedData);
    payload.url_path = formatUrl(payload.url_path);

    let result = {};
    if (selectedData.id) {
      result = await put(
        FILE_UPLOAD + `/${selectedData.id}`,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
    } else {
      result = await post(
        FILE_UPLOAD,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
    }

    let { status, message, data } = result;

    if (status) {
      setLoading(false);

      let filesArr = _.cloneDeep(files);

      // On Update
      if (selectedData.id) {
        const index = files.findIndex((el) => el.id == selectedData.id);
        filesArr[index] = data;
      } else {
        filesArr.push(data);
      }

      setFiles(filesArr);
      handleCloseModal();
    } else {
      setLoading(false);
    }

    showToast(status, message);
  };

  const handleCloseModal = () => {
    setSelectedData(emptyCustomUrlData);
    setShowModal(false);
  };

  const loadCustomUrls = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      FILE_UPLOAD,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      if (data.length > 0) {
        setFiles(data);
      }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadCustomUrls();
  }, []);

  const filteredItems = useMemo(() => {
    const filtered = files.filter(
      (item) =>
        `${item?.user_data?.first_name || ""} ${
          item?.user_data?.last_name || ""
        }`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.title.toLowerCase().includes(filterText.toLowerCase()) ||
        item.url_path.includes(filterText.toLowerCase())
    );

    return filtered;
  }, [filterText, files]);

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Title",
      width: "200px",
      cell: (row) => (
        <div className="profileWrapper">
          <p className="globalDetail">{row.title}</p>
        </div>
      ),
    },
    {
      name: "Username",
      width: "200px",
      cell: (row) => (
        <div className={"globalDetail"}>
          {row?.user_data?.first_name} {row?.user_data?.last_name}
        </div>
      ),
    },
    {
      name: "Url",
      width: "220px",
      cell: (row) => (
        <div className="profileWrapper">
          <a
            href={row.url_path}
            className="globalDetail"
            target="_blank"
            style={{ display: "block" }}
            rel="noreferrer"
          >
            {row.url_path}
          </a>
        </div>
      ),
    },
    {
      name: "Created in",
      width: "150px",
      cell: (row) => (
        <div className={"globalDetail"}>
          {row?.team_detail !== null ? "Team Mode" : "Individual"}
        </div>
      ),
    },
    {
      name: "Team Name",
      width: "200px",
      cell: (row) => (
        <div className={"globalDetail"}>
          {row?.team_detail !== null ? row?.team_detail?.name : "-"}
        </div>
      ),
    },
    {
      name: "Action",
      right: "true",
      cell: (row) => (
        <div className={classes.action}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <a
                className="dropdown-item"
                href={baseUrl.AWS_URL + row.url_path}
                target="_blank"
                rel="noreferrer"
              >
                Visit Link
              </a>
            </li>
            <li>
              <Link
                className="dropdown-item"
                onClick={() => handleShowModal(row)}
              >
                Edit
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="#"
                // style={{ color: "#E35252" }}
                onClick={() => handleDelete(row.id)}
              >
                Delete
              </Link>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (id) => {
    setDeleteId(id);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status, message } = await deleteRecord(
      `${FILE_UPLOAD}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);

    if (status) {
      await loadCustomUrls();
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <>
      {!loading ? (
        <div className="">
          <div className="page_Header">
            <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3 mb-3">
              <div class="heading">
                <h1 className="pageTitle">
                  File Upload URLS'S<span>({files.length})</span>
                </h1>
              </div>
              {/* <FormInput
                icon={searchIcon}
                placeholder="Search..."
                value={filterText}
                handleChange={handleFilter}
              /> */}
              <div
                className="input-group"
                style={{ maxWidth: "250px", height: "45px" }}
              >
                <span className="input-group-text bg-white border-end-0">
                  <img
                    src={searchIcon}
                    alt="search"
                    style={{ height: "16px" }}
                  />
                </span>
                <input
                  type="text"
                  className="form-control border-start-0"
                  placeholder="Search..."
                  value={filterText}
                  onChange={handleFilter}
                />
              </div>
            </div>
          </div>

          <div className="default-list-table">
            <DataTable
              columns={columns}
              data={filteredItems}
              paginationResetDefaultPage={resetPaginationToggle}
              pagination
              theme="solarized"
            />
          </div>

          <ConfirmationModal
            show={showConfirmationModal}
            handleCloseModal={handleCloseConfirmationModal}
            handleConfirmDelete={handleConfirmDelete}
          />

          {/* Custom url modals */}
          {showModal && (
            <FileUploadAddEditModal
              show={showModal}
              data={selectedData}
              setSelectedData={setSelectedData}
              handleSaveShowModal={handleSaveShowModal}
              handleCloseModal={handleCloseModal}
            />
          )}
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default AllFileUpload;
